const imageMimeTypes = ['image/jpeg', 'image/png', 'image/gif'] as const;
const pdfMimeTypes = ['application/pdf'] as const;
const allowedMimeTypes = [...imageMimeTypes, ...pdfMimeTypes] as const;

export type ImageMimeType = (typeof imageMimeTypes)[number];
export type PdfMimeType = (typeof pdfMimeTypes)[number];
export type FileAttachmentType = ImageMimeType | PdfMimeType;

export function isValidMimeType(mimeType: string): boolean {
  return allowedMimeTypes.includes(mimeType as FileAttachmentType);
}
export function isImageType(mime: string): mime is ImageMimeType {
  return imageMimeTypes.includes(mime as ImageMimeType);
}
export function isPdfType(mime: string): mime is PdfMimeType {
  return pdfMimeTypes.includes(mime as PdfMimeType);
}

export interface FileAttachment {
  filename: string;
  attachmentData: string | ArrayBuffer;
  mimeType: FileAttachmentType;
}
